import React, {Component} from 'react';
import {
  Container,
  Row,
  Col
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';

import Button from '../../../shared/components/Button';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import DropdownButton from '../../../shared/components/DropdownButton';

import {
  recursivelyLoadAllPages,
  alphabeticallySort,
  textContains
} from '../../../shared/utils';

class BrandList extends Component {
  constructor(){
    super();

    this.state = {
      isLoading:false,
      searchText:''
    };
  }

  componentDidMount(){
    this.setState({isLoading:true});

    Promise.all([
      recursivelyLoadAllPages(this.props.loadBrands,100),
      recursivelyLoadAllPages(this.props.loadAgencies,100),
      this.props.loadKPIsForBrands()
    ])
      .then(() => this.setState({isLoading:false}))
      .catch(() => this.setState({isLoading:false}));
  }

  render(){
    const { updateBrand, brands } = this.props;

    return (
      <Container>
        <Row className='EntityList-title'>
          <Col xs='6'>
            <h1>Brands</h1>
          </Col>
          <Col xs='6'>
            <Button
              className='pull-right'
              linkHref='/superadmin/brands/new'
            >
              Create Brand
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <SearchableDataTable
              items={brands}
              emptyText='Loading brands...'
              searchPromptText='Search by name or account'
              isActiveFunc={(item) => item.active}
              columns={[
                {
                  name:'logo',
                  width:10,
                  renderCell:(item) => (
                    <div>
                      {item.logoURL ? (
                        <img
                          style={{ height:50 }}
                          src={item.logoURL}
                          alt={`Logo for brand ${item.name}`}
                        />
                      ) : (
                        <span>N/A</span>
                      )}
                    </div>
                    )
                },{
                  display:'Brand',
                  name:'name',
                  width:30,
                  sortFunc:(a,b) => alphabeticallySort(a.name,b.name),
                  filterFunc:(a,searchParam) => textContains(a.name,searchParam),
                  renderCell:(item) => (
                    <div>
                      <Link to={`/superadmin/brands/${item.id}/edit`}>{item.name}</Link>
                    </div>
                    )
                },{
                  display:'Account',
                  name:'agencyName',
                  width:20,
                  sortFunc:(a,b) => alphabeticallySort(a.agencyName,b.agencyName),
                  filterFunc:(a,searchParam) => textContains(a.agencyName,searchParam),
                  renderCell:(item) => (
                    <div>
                      <Link to={`/superadmin/accounts/${item.agencyId}/brands`}>{item.agencyName}</Link>
                    </div>
                  )
                },{
                  display:'Experiences',
                  name:'totalCampaigns',
                  width:15,
                  sortFunc:(a,b) => b.totalCampaigns - a.totalCampaigns,
                  renderCell:(item) => (
                    <div>
                      <Link to={`/superadmin/brands/${item.id}/experiences`}>{item.totalCampaigns}</Link>
                    </div>
                  )
                },{
                  width:25,
                  alwaysActive:true,
                  renderCell:(item) => (
                    <div className='pull-right'>
                      <Button
                        size='sm'
                        linkHref={`/superadmin/brands/${item.id}/edit`}
                        textColor='#666666'
                        borderColor='#cccccc'
                        backgroundColor='#fff'
                      >
                        Edit
                      </Button>
                      &nbsp;&nbsp;
                      <DropdownButton
                        options={[
                          {
                            text:item.active ? 'Deactivate' : 'Activate',
                            onClick:() => updateBrand(item.id,{active:!item.active})
                          }
                        ]}
                      />
                    </div>
                  )
                }
              ]}
            />
            <br />
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default BrandList;



// WEBPACK FOOTER //
// ./src/routes/BrandList/components/BrandList.js